module.exports = __webpack_public_path__ + "media/images/plans/propose_original/main-f95666489dd3863ef90a5581a06471a8.jpg";